
import React, { useEffect } from 'react';
import './css/App.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';
import { removeAll } from './hooks/hooks.localStorage';
import { useLocation } from 'react-router-dom';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import BasicRouting from './routing/routing.basicRouting';
import SecurityRouting from './routing/routing.securityRouting';
import { handleGet } from './controllers/controller.all';
import GlobalSlowLoader from './components/ui/GlobalSlowLoader';

function App() {

  const user= useSelector((state)=>state.userReducer.user);
  const token= useSelector((state)=>state.userReducer.token);
  const limit= useSelector((state)=>state?.userReducer?.limit);
  const dispatch= useDispatch();
  const location= useLocation();

  const logout= ()=>{
    dispatch({type: "logout"});
    removeAll();
  }

  // Auto-logout on 403 Forbidden from any API call
  useEffect(()=>{
    const handleForbidden = () => logout();
    window.addEventListener("auth:forbidden", handleForbidden);
    return () => window.removeEventListener("auth:forbidden", handleForbidden);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(()=>{
    if (!token) return; // If already logged out, do nothing to prevent infinite loop

    const now= moment();
    // Auto-logout if user is missing/empty, or session has expired (> 1 month)
    if (!user || Object.keys(user).length === 0 || (limit && now.diff(moment(limit), "M")>=1)){
      logout();
    } else if (user?._id) {
      // Verify user still exists in the database using the controller.
      // If deleted, checkStatus intercepts 401/404 and triggers auth:forbidden.
      handleGet(`/user/${user._id}`, () => {}, token);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user, limit, location])


  return (
    <div className="App">
      {
        ["ADMIN", "SUPER_ADMIN"].includes(user?.role) ? <BasicRouting /> : <SecurityRouting />
      }
      <ToastContainer />
      <GlobalSlowLoader />
    </div>
  );
}

export default App;
